import api from './api';
import { Motorista, ApiResponse } from '../types';

export const motoristaService = {
  listar: async (): Promise<Motorista[]> => {
    const response = await api.get<Motorista[]>('/motoristas');
    return response.data;
  },

  buscarPorId: async (id: number): Promise<Motorista> => {
    const response = await api.get<Motorista>(`/motoristas/${id}`);
    return response.data;
  },

  listarPorVeiculo: async (veiculoId: number): Promise<Motorista[]> => {
    const response = await api.get<Motorista[]>(`/motoristas/por-veiculo/${veiculoId}`);
    return response.data;
  },

  cadastrar: async (motorista: Motorista): Promise<ApiResponse<Motorista>> => {
    const response = await api.post<ApiResponse<Motorista>>('/motoristas', motorista);
    return response.data;
  },

  atualizar: async (id: number, motorista: Motorista): Promise<ApiResponse<Motorista>> => {
    const response = await api.put<ApiResponse<Motorista>>(`/motoristas/${id}`, motorista);
    return response.data;
  },

  deletar: async (id: number): Promise<ApiResponse<void>> => {
    const response = await api.delete<ApiResponse<void>>(`/motoristas/${id}`);
    return response.data;
  },

  alocarVeiculo: async (motoristaId: number, veiculoId: number): Promise<ApiResponse<void>> => {
    const response = await api.post<ApiResponse<void>>(`/motoristas/${motoristaId}/veiculos/${veiculoId}`);
    return response.data;
  },

  desalocarVeiculo: async (motoristaId: number, veiculoId: number): Promise<ApiResponse<void>> => {
    const response = await api.delete<ApiResponse<void>>(`/motoristas/${motoristaId}/veiculos/${veiculoId}`);
    return response.data;
  },
};
